import React from 'react';
import DisplayForm from './DisplayForm';
import { addDisplay } from '../../api';

export default class extends React.Component {

  constructor(props, context) {
    super(props, context);
    this.appBar = {
      title: 'NEW_DISPLAY',
      navigateBack: true,
    };
  }

  render() {
    return (
      <DisplayForm
        name="addDisplay"
        appBar={this.appBar}
        request={addDisplay}
        getLists
        confirmExit
      />
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/routes/Display/DisplayAddition.js
 **/